import { render } from "./OmnyConfirmContinueModal.vue?vue&type=template&id=85efb21a"
import script from "./OmnyConfirmContinueModal.vue?vue&type=script&lang=js"
export * from "./OmnyConfirmContinueModal.vue?vue&type=script&lang=js"

import "./OmnyConfirmContinueModal.vue?vue&type=style&index=0&id=85efb21a&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__